import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "hstack gap-1 h-100" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["list"]
const _hoisted_5 = ["id"]
const _hoisted_6 = ["value"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.label != '')
      ? (_openBlock(), _createElementBlock("label", _hoisted_2, _toDisplayString(_ctx.label), 1))
      : _createCommentVNode("", true),
    (_ctx.items != undefined && _ctx.items.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _withDirectives(_createElementVNode("input", {
            class: "form-control h-100",
            list: _ctx.randomId,
            placeholder: "Type to search...",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterValue) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args)))
          }, null, 40, _hoisted_4), [
            [_vModelText, _ctx.filterValue]
          ]),
          _createElementVNode("datalist", { id: _ctx.randomId }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
              return (_openBlock(), _createElementBlock("option", {
                value: item.text
              }, null, 8, _hoisted_6))
            }), 256))
          ], 8, _hoisted_5)
        ]))
      : _withDirectives((_openBlock(), _createElementBlock("input", {
          key: 2,
          class: "form-control h-100",
          placeholder: "",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filterValue) = $event)),
          onKeyup: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleChange && _ctx.handleChange(...args)))
        }, null, 544)), [
          [_vModelText, _ctx.filterValue]
        ])
  ]))
}